import React from "react";
import { PaSkeleton } from "components/platform-admin";
import { AiChartWidgetSkeleton } from "pages/ServiceProvider/SpSetting/AiCreditsUsage/AiCreditsUsageSkeleton";

const Pulse = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-gray-200/80 ${className}`} />
);

const KpiSkeleton = () => (
  <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
    <Pulse className="h-3 w-24" />
    <Pulse className="mt-2 h-8 w-28" />
    <Pulse className="mt-2 h-3 w-20" />
  </div>
);

const AiUsageOverviewSkeleton = () => (
  <>
    <div className="mb-4 flex flex-wrap items-end gap-3">
      <div className="space-y-2">
        <Pulse className="h-3 w-16" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <Pulse key={index} className="h-8 w-24 rounded-full" />
          ))}
        </div>
      </div>
      <div className="space-y-2">
        <Pulse className="h-3 w-14" />
        <Pulse className="h-9 w-40 rounded-lg" />
      </div>
    </div>

    <div className="mb-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: 4 }).map((_, index) => (
        <KpiSkeleton key={index} />
      ))}
    </div>

    <div className="mb-6 grid items-start gap-5 xl:grid-cols-2">
      <AiChartWidgetSkeleton variant="area" />
      <AiChartWidgetSkeleton variant="bar" />
    </div>

    <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="border-b border-gray-100 px-4 py-3">
        <Pulse className="h-4 w-36" />
      </div>
      <div className="p-6">
        <PaSkeleton variant="table" lines={6} />
      </div>
    </div>
  </>
);

export default AiUsageOverviewSkeleton;
